// src/components/Beautify.jsx
export default function Beautify() {
  return (
    <section id="beautify" className="bg-[#F2F5FF]">
      <div className="mx-auto max-w-6xl px-6 py-12 grid items-center gap-10 md:grid-cols-2">
        {/* Left: copy */}
        <div className="max-w-md">
          <h2 className="text-2xl md:text-3xl font-extrabold text-[#054C73]">
            Beautify Your Space
          </h2>
          <p className="mt-4 text-gray-600 leading-relaxed">
            Do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
            quis nostrud exercitation ullamco laboris.
          </p>
          <button
            className="mt-6 inline-block rounded-full bg-[#054C73] text-white px-6 py-3 font-semibold shadow-md
                       hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-[#054C73] focus:ring-offset-2"
          >
            Learn More
          </button>
        </div>

        {/* Right: image with green circle behind */}
        <div className="relative flex justify-center md:justify-end">
          {/* Circle behind the image */}
          <div
            className="hidden sm:block absolute z-0
                       w-40 h-40 md:w-60 md:h-60
                       bg-[#09513B] rounded-full
                       -right-6 md:-right-10 top-1/2 -translate-y-1/2"
            aria-hidden="true"
          />
          {/* The image */}
          <img
            src="/images/Mask Group (1).png"  // coloca aquí tu ruta real
            alt="Decor inspiration"
            loading="lazy"
            className="relative z-10 rounded-[24px] shadow-lg
                       w-60 sm:w-72 md:w-[360px] h-auto object-cover"
          />
        </div>
      </div>
    </section>
  );
}
